module.exports = __webpack_public_path__ + "static/media/Nails01.6f7b4deb.jpeg";